import {
  Facebook,
  Instagram,
  MailOutlined,
  MapOutlined,
  PhoneOutlined,
  Pinterest,
  Twitter,
} from "@material-ui/icons";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;
const Center = styled.div`
  flex: 1;
  padding: 20px;
`;

const Title = styled.h3`
  margin-bottom: 30px;
`;

const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
`;

const ListItem = styled.li`
  width: 50%;
  margin-bottom: 10px;
`;

const Right = styled.div`
  flex: 1;
  padding: 20px;
`;

const Logo = styled.h1`
  text-decoration: none;
  text-decoration-color: none;
  color: #000000;
`;

const Desc = styled.p`
  margin: 20px 0px;
`;

const SocialContainer = styled.div`
  display: flex;
`;

const ContactItem = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`;

const Payment = styled.img`
  width: 50%;
`;

const SocialIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  /* paint the background color of each icon with the color props */
  background-color: #${(props) => props.color};
`;

const Footer = () => {
  return (
    <Container>
      <Left>
        <Link
          style={{ textDecoration: "none", textDecorationLine: "none" }}
          to="/"
        >
          <Logo>Trébuché.</Logo>{" "}
        </Link>
        <Desc>
          {" "}
          This is a Dummy description for my first store website, since loren is
          too basic I decided to write some corporate filling in here{" "}
        </Desc>
        <SocialContainer>
          <SocialIcon color="3B5999">
            <Facebook />
          </SocialIcon>
          <SocialIcon color="E4405F">
            <Instagram a />
          </SocialIcon>
          <SocialIcon color="55ACEE">
            <Twitter />
          </SocialIcon>
          <SocialIcon color="E60023">
            <Pinterest />
          </SocialIcon>
        </SocialContainer>
      </Left>
      <Center>
        <Title>Useful Links</Title>
        <List>
          <ListItem>Home</ListItem>
          <ListItem>Cart</ListItem>
          <ListItem>Man Fashion</ListItem>
          <ListItem>Woman Fashion</ListItem>
          <ListItem>Accessories</ListItem>
          <ListItem>My Account</ListItem>
          <ListItem>Order Tracking</ListItem>
          <ListItem>Wishlist</ListItem>
          <ListItem>Wishlist</ListItem>
          <ListItem>Terms</ListItem>
        </List>
      </Center>
      <Right>
        <Title>Contact</Title>
        <ContactItem>
          {" "}
          <MapOutlined style={{ marginRight: "10px" }} /> 22 Boulevard de
          Belleville{" "}
        </ContactItem>
        <ContactItem>
          {" "}
          <PhoneOutlined style={{ marginRight: "10px" }} />
          +1 234 567 890
        </ContactItem>
        <ContactItem>
          {" "}
          <MailOutlined style={{ marginRight: "10px" }} />{" "}
          contact@fashionjob.com
        </ContactItem>
        <Payment src="https://i.ibb.co/Qfvn4z6/payment.png" />
      </Right>
    </Container>
  );
};

export default Footer;
